import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { IoClose } from 'react-icons/io5';
import { LuDownload, LuSmartphone } from 'react-icons/lu';
import { BASE_URL } from '../constants/Url';
import { APP_IOS_URL } from '../config/api';

function AppStoreDownloadModal(props, ref) {
    const [open, setOpen] = useState(false);
    const { t } = useTranslation();

    const showModal = () => setOpen(true);
    const closeModal = () => setOpen(false);

    useImperativeHandle(ref, () => ({
        showModal,
        closeModal,
    }));

    const handleDownload = () => {
        window.open(APP_IOS_URL, '_blank');
        closeModal();
    };

    return (
        <Modal
            centered
            open={open}
            onCancel={closeModal}
            footer={null}
            closeIcon={null}
            width={'32rem'}
            destroyOnClose={true}
            className="esi-appstore-modal"
            styles={{
                content: {
                    borderRadius: '24px',
                    padding: 0,
                    overflow: 'hidden',
                    boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                },
            }}
        >
            <div className="relative p-7 sm:p-9 bg-white text-gray-800">
                {/* Close Button */}
                <button
                    onClick={closeModal}
                    aria-label="Close"
                    className="absolute top-3 right-3 sm:top-4 sm:right-4 text-gray-400 hover:text-gray-600 transition-colors p-2 rounded-full hover:bg-gray-100 focus:outline-none cursor-pointer z-10 flex items-center justify-center"
                >
                    <IoClose className="text-xl sm:text-2xl" />
                </button>

                {/* Content */}
                <div className="flex flex-col items-center text-center">
                    {/* App Logo */}
                    <div className="w-20 h-20 sm:w-24 sm:h-24 flex items-center justify-center">
                        <img
                            src={BASE_URL + "/home/logoApp.png"}
                            alt="ESIPRO Logo"
                            className="w-full h-full object-contain"
                        />
                    </div>

                    {/* Badge */}
                    <div className="mt-3">
                        <span className="inline-block bg-[#F4EBFD] text-[#8637df] text-xs sm:text-sm font-medium px-3 py-1 rounded-md">
                            {t("text_app_intl_edition")}
                        </span>
                    </div>

                    {/* Heading */}
                    <h3 className="mt-2.5 text-xl sm:text-2xl font-bold text-gray-900 tracking-wide">
                        {t("text_appstore_down")}
                    </h3>

                    {/* Action Button */}
                    <button
                        onClick={handleDownload}
                        className="w-full mt-6 flex items-center justify-center gap-2.5 py-3.5 sm:py-4 px-6 bg-[#232328] hover:bg-[#19191d] text-white rounded-lg text-base sm:text-lg font-medium tracking-wide transition-all shadow-sm active:scale-[0.99] cursor-pointer"
                    >
                        <LuDownload className="text-xl sm:text-2xl" />
                        <span>{t("text_download_esipro_app")}</span>
                    </button>

                    {/* Notice Card for Mainland China */}
                    <div className="w-full mt-5 bg-[#F8F6FD] border border-[#EFE7FB] rounded-2xl p-4 sm:p-5 text-left flex items-start gap-3.5">
                        <LuSmartphone className="text-2xl text-[#8637DF] shrink-0 mt-0.5" />
                        <div className="flex flex-col">
                            <span className="text-xs sm:text-sm font-semibold text-gray-800 leading-snug">
                                {t("text_app_modal_notice_title")}
                            </span>
                            <span className="text-[11px] sm:text-xs text-gray-500 mt-1 leading-relaxed">
                                {t("text_app_modal_notice_sub")}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}

export default forwardRef(AppStoreDownloadModal);
